const requestCache = new Map();
const pendingRequests = new Map();

const CACHE_TTL = 2000;

function getCacheKey(url, params) {
  const sortedParams = Object.keys(params || {})
    .sort()
    .reduce((acc, key) => {
      acc[key] = params[key];
      return acc;
    }, {});
  return `${url}?${JSON.stringify(sortedParams)}`;
}

function isCacheValid(entry) {
  if (!entry) return false;
  return Date.now() - entry.timestamp < CACHE_TTL;
}

export async function cachedRequest(requestFn, url, params = {}) {
  const cacheKey = getCacheKey(url, params);

  if (pendingRequests.has(cacheKey)) {
    return pendingRequests.get(cacheKey);
  }

  const cached = requestCache.get(cacheKey);
  if (isCacheValid(cached)) {
    return Promise.resolve(cached.data);
  }

  const promise = requestFn().then(response => {
    requestCache.set(cacheKey, {
      data: response,
      timestamp: Date.now()
    });
    pendingRequests.delete(cacheKey);
    return response;
  }).catch(error => {
    pendingRequests.delete(cacheKey);
    throw error;
  });

  pendingRequests.set(cacheKey, promise);
  return promise;
}

export function clearCache() {
  requestCache.clear();
  pendingRequests.clear();
}

export function clearCacheForUrl(url) {
  const keysToDelete = [];
  requestCache.forEach((value, key) => {
    if (key.startsWith(url)) {
      keysToDelete.push(key);
    }
  });
  keysToDelete.forEach(key => {
    requestCache.delete(key);
    pendingRequests.delete(key);
  });
}
